module.exports = __webpack_public_path__ + "img/emergency_assistance_icon.e3d8a539.webp";